/**
 * GMCC Specials → Flyers hub。
 * 打开页面打 STATSIG.COMMON.VIEW，value=flyers_hub。
 *
 * 正在用：打开 Flyers hub；左侧切具体 flyer；下载 flyer；下载时带 realtor 记获客。
 * 已不算：填地址 / realtor、预览、关弹窗。
 * Program maps 里的 flyer、Open house finder、落地页不跨模块。
 */
export enum GmccFlyersHubEvent {
    /**
     * 切左侧具体 flyer。
     * 属性 tab 用菜单 key，如 gmcc_universe|gmcc_massive|gmcc_dscr
     */
    TAB = 'FLYERS_HUB_TAB',
    /** 下载 flyer */
    DOWNLOAD = 'FLYERS_HUB_DOWNLOAD',
    /** 下载时带 realtor 信息，记一笔获客 */
    LEAD = 'FLYERS_HUB_LEAD',
}
